import { Navigate, useParams } from "react-router-dom";

/** The retired Exe Mission Validation URLs (`/admin/exe-mission-validation[/:jobId]`) open Job Errors on its Exe
 *  Validation tab, keeping the selected job. */
export const ExeMissionValidationRedirect: React.FC = () => {
	const { jobId } = useParams<{ jobId?: string }>();
	const path = jobId ? `/admin/job-errors/${encodeURIComponent(jobId)}` : "/admin/job-errors";
	return <Navigate to={`${path}?tab=exe`} replace />;
};
